<template>
  <div>
    <div>
      <div class="record-card">
        <div class="card-item car-title">
          <div
            class="item-left"
            style="flex: 0 0 89px"
          >提现金额：</div>
          <div
            class="item-right"
            style="margin-left: 4px"
          >
            ￥{{ record.collectionAmt || 0 }}
          </div>
        </div>
        <div class="card-item">
          <div class="item-left">提现时间</div>
          <div class="item-right">
            {{ record.createdTime }}
          </div>
        </div>
        <div class="card-item">
          <div class="item-left">提现账号</div>
          <div class="item-right">
            {{ record.collectionTypeDesc }}
            {{ record.collectionAccount }}
          </div>
        </div>
        <div class="card-item">
          <div class="item-left">提现单号</div>
          <div class="item-right">
            {{ record.payNo }}
          </div>
        </div>
        <div class="card-item">
          <div class="item-left">状态</div>
          <div class="item-right">
            {{ record.payStatusDesc }}
          </div>
        </div>
        <div class="card-item">
          <div class="item-left">备注</div>
          <div class="item-right">
            {{ record.exceptionReason || "" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    record: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  onLoad(options) {
    console.log('onLoad:', options);
  },
  onReady() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.record-card {
  // 	background: #FFFFFF;
  // 	border-radius: 8px;
  // 	padding: 16px;
  //   margin-bottom: 12px;
  .card-item {
    display: flex;
    .item-left {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #999999;
      letter-spacing: 0.48px;
      font-weight: 400;
      min-width: 82px;
    }
    .item-right {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #383838;
      letter-spacing: 0.48px;
      font-weight: 400;
      word-break: break-all;
      margin-left: 15px;
    }

    .bold {
      font-family: PingFangSC-Medium;
      font-weight: 500;
    }

    & + .card-item {
      margin-top: 16px;
    }

    &.car-title {
      .item-left {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #383838;
      }
      .item-right {
        font-family: PingFangSC-Medium;
        color: #ff8a59;
        font-weight: 500;
      }
    }
  }
}
.blank-wrap {
  padding-top: 90px;
}
</style>
